import React from 'react';
import {
  Grid,
  Box,
  Typography,
  useTheme
} from '@mui/material';
import {
  Science,
  Devices,
  Palette,
  Business,
  LocalLibrary,
  HealthAndSafety,
  HistoryEdu,
  Psychology,
  MenuBook
} from '@mui/icons-material';

const KnowledgeExchangeFields = () => {
  const categories = [
    {
      title: "Science",
      description: "Exchange knowledge on scientific discoveries and innovations.",
      icon: <Science sx={{ fontSize: 40, color: '#00E5FF' }} />,
      bgGradient: 'linear-gradient(135deg, #1D2671, #C33764)'
    },
    {
      title: "Technology",
      description: "Discuss the latest in tech, programming, and innovations.",
      icon: <Devices sx={{ fontSize: 40, color: '#FF6F00' }} />,
      bgGradient: 'linear-gradient(135deg, #2b5876, #4e4376)'
    },
    {
      title: "Design",
      description: "Share your design ideas, trends, and creative work.",
      icon: <Palette sx={{ fontSize: 40, color: '#F06292' }} />,
      bgGradient: 'linear-gradient(135deg, #fc466b, #3f5efb)'
    },
    {
      title: "Business",
      description: "Learn and discuss strategies, startups, and entrepreneurship.",
      icon: <Business sx={{ fontSize: 40, color: '#26A69A' }} />,
      bgGradient: 'linear-gradient(135deg, #0f2027, #2c5364)'
    },
    {
      title: "Education",
      description: "Exchange knowledge on teaching, learning, and academic growth.",
      icon: <LocalLibrary sx={{ fontSize: 40, color: '#FFCA28' }} />,
      bgGradient: 'linear-gradient(135deg, #355C7D, #6C5B7B)'
    },
    {
      title: "Health & Medicine",
      description: "Share medical insights, health tips, and breakthroughs.",
      icon: <HealthAndSafety sx={{ fontSize: 40, color: '#E91E63' }} />,
      bgGradient: 'linear-gradient(135deg, #42275a, #734b6d)'
    },
    {
      title: "Culture & History",
      description: "Discuss history, culture, and the impact of past events.",
      icon: <HistoryEdu sx={{ fontSize: 40, color: '#81D4FA' }} />,
      bgGradient: 'linear-gradient(135deg, #141E30, #243B55)'
    },
    {
      title: "Social Sciences",
      description: "Engage in conversations about psychology, sociology, and more.",
      icon: <Psychology sx={{ fontSize: 40, color: '#FFD600' }} />,
      bgGradient: 'linear-gradient(135deg, #283c86, #45a247)'
    },
    {
      title: "Literature",
      description: "Exchange thoughts on books, writing, poetry, and more.",
      icon: <MenuBook sx={{ fontSize: 40, color: '#00E5FF' }} />,
      bgGradient: 'linear-gradient(135deg,rgba(238, 156, 167, 0.73),rgba(255, 221, 225, 0.72))'
    }
  ];

  return (
    <Box
      sx={{
        background: '#000000',
        color: 'white',
        padding: '60px 20px',
        textAlign: 'center',
        borderRadius: '20px',
        overflow: 'hidden',
        mt: 6,
      }}
    >
      <Typography
        variant="h3"
        component="h2"
        sx={{
          fontWeight: 'bold',
          letterSpacing: 3,
          textTransform: 'uppercase',
          color: 'white',
          mb: 2,
          fontSize: { xs: '1.8rem', md: '2.8rem' },
        }}
      >
        Explore Diverse Fields
      </Typography>

      <Typography
        sx={{
          color: '#bbbbbb',
          maxWidth: 600,
          mx: 'auto',
          fontSize: '1rem',
          mb: 6,
        }}
      >
        Vishwamitra supports rich knowledge exchange—from science and technology to humanities, arts, and business.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {categories.map((category, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                background: category.bgGradient,
                borderRadius: '16px',
                padding: '30px 20px',
                textAlign: 'center',
                transition: 'all 0.4s ease',
                cursor: 'pointer',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
                '&:hover': {
                  transform: 'scale(1.03)',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.6)',
                },
              }}
            >
              <Box
                sx={{
                  width: '75px',
                  height: '75px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '0 auto 20px auto',
                }}
              >
                {category.icon}
              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  color: 'white',
                  letterSpacing: 1,
                  mb: 1,
                }}
              >
                {category.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: '#e0e0e0',
                  fontSize: '0.95rem',
                  px: 1,
                }}
              >
                {category.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default KnowledgeExchangeFields;
